import React from 'react';

import loadingImg from './loading.svg';
import './Loading.scss';

const Loading = () => (
  <div className='loading-container'>
    <img className='loading-image' src={loadingImg} alt='Fetching' />
  </div>
);

export default Loading;
